
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/whatsapp-real-estate",
      function () {
        return require("private-next-pages/webinars/whatsapp-real-estate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/whatsapp-real-estate"])
      });
    }
  